import createDonutChartOptions, { ChartDatum } from 'lib/agCharts/donutChart';
import { currenciesMap } from 'lib/constants/currencies';
import { useGetEventFinancialDataQuery } from 'lib/graphql/graphql';
import useEvent from 'providers/event/useEvent';
import LanguageContext from 'providers/i18n/LanguageContext';
import { useContext, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import ChartCard from '../ChartCard/ChartCard';

interface SalesBreakdownChartProps {
  currency: string
}

function SalesBreakdownChart(props: SalesBreakdownChartProps) {
  const { currency } = props;

  const { id: eventId } = useEvent();
  const { language } = useContext(LanguageContext);

  const { formatMessage } = useIntl();

  const {
    data,
    loading,
  } = useGetEventFinancialDataQuery({ variables: { eventId } });
  const aggregate = data?.getEventFinancialData;

  const chartOptions = useMemo(() => {
    if (aggregate) {
      const symbol = currenciesMap[currency.toUpperCase()]?.symbol || '$';
      const chartData: ChartDatum[] = [
        { amount: aggregate.eventAmount / 100, asset: 'Organization', unit: symbol },
        { amount: aggregate.movonAmount / 100, asset: 'MovOn.VIP', unit: symbol },
        { amount: aggregate.obnlAmount / 100, asset: formatMessage({ id: 'supported_organizations' }), unit: symbol },
        { amount: aggregate.feeAmount / 100, asset: 'Stripe', unit: symbol },
        { amount: aggregate.taxAmount / 100, asset: formatMessage({ id: 'taxes' }), unit: symbol },
      ];
      return createDonutChartOptions(chartData, language, formatMessage({ id: 'total_sales' }));
    }
    return {};
  }, [aggregate, currency, formatMessage, language]);

  return (
    <ChartCard
      title={<FormattedMessage id="sales_breakdown" />}
      loading={loading}
      chartOptions={chartOptions}
    />
  );
}

export default SalesBreakdownChart;
